import React from 'react';

import arrayMutators from 'final-form-arrays';
import { Field, Form } from 'react-final-form';

import Button from 'components/shared/Button';
import Divider from 'components/shared/Divider';
import FormActions from 'components/shared/FormAdapters/FormDefault/FormActions';
import FormGroupAdapter from 'components/shared/FormAdapters/FormDefault/FormGroup';
import FormGroup from 'components/shared/FormAdapters/FormDefault/FormGroup/Base';
import LabelWrapper from 'components/shared/FormAdapters/FormDefault/Label/Wrapper';
import Loader from 'components/shared/Loader';
import FormTitle from 'components/shared/Typography/FormTitle';
import Text from 'components/shared/Typography/Text';
import Title from 'components/shared/Typography/Title';
import { ERROR_MESSAGES } from 'utils/yup';

import { ITINERARIES_ITEM_TO_LABEL_MAP, ITINERARIES_ITEM_TO_SHARING_MODAL_MAP, SHARE_TYPE } from '../constants';
import ProposalLink from '../Content/CopyLink/ProposalLink';
import Contacts from './Contacts';
import useForm from './functions';
import s from './index.module.css';

function validateRequired({ message } = {}) {
  return (value) => {
    if (!value) return message ?? ERROR_MESSAGES.message;
    return undefined;
  };
}

function ShareForm(props) {
  const {
    shareWithType,
    showPermissions = false,
    showProposalLink = true,
    itinerariesItemType,
    manageHideCosts = false,
    hideHideCosts = false,
  } = props;
  const { validate, handleSubmit, link, handleCopyLink, handleSaveLink, loadTailInfo, loading } = useForm(props);
  const SHARING_MODAL = ITINERARIES_ITEM_TO_SHARING_MODAL_MAP[itinerariesItemType];

  return (
    <>
      <div id="internal-modal" />
      <Form
        onSubmit={handleSubmit}
        keepDirtyOnReinitialize
        initialValues={{
          clients: [{}],
          link,
          guestPortalHideCosts: !manageHideCosts,
        }}
        validate={validate}
        mutators={{
          ...arrayMutators,
        }}
        render={({
          handleSubmit,
          submitting,
          form: {
            mutators: { push },
          },
          hasValidationErrors,
        }) => (
          <form onSubmit={handleSubmit} autoComplete="off">
            {loading && <Loader isFillBlock />}

            {shareWithType === SHARE_TYPE.FRIEND && (
              <>
                <Title
                  italic
                  level={5}
                  weight="normal"
                  className={s.shareWithFriendsTitleStyle}
                  noTransform
                  noMargin
                  data-block
                >
                  Share this Guest Portal with friends
                </Title>
                <Divider className={s.divider} />
              </>
            )}

            <div className={s.section}>
              <LabelWrapper>
                <Text accent>{SHARING_MODAL[shareWithType].top}</Text>
              </LabelWrapper>
              <Contacts push={push} shareWithType={shareWithType} itinerariesItemType={itinerariesItemType} />
              {/* <Itineraries itineraries={itineraries} activeItineraries={activeItineraries} onAddIds={handleAddIds} /> */}
              {/* {activeItineraries?.length > 1 && (
                <PagePhoto landingPagePhoto={landingPagePhoto} setLandingPagePhoto={setLandingPagePhoto} />
              )} */}

              {showPermissions && !hideHideCosts && (
                <>
                  <FormTitle hint={`Configure ${ITINERARIES_ITEM_TO_LABEL_MAP[itinerariesItemType]} visibility below.`}>
                    Manage Permissions
                  </FormTitle>

                  <Field
                    component={FormGroupAdapter}
                    name="guestPortalHideCosts"
                    type="checkbox"
                    labelText="Hide Costs"
                    disabled={!manageHideCosts}
                  />
                </>
              )}

              {shareWithType !== SHARE_TYPE.FRIEND && (
                <>
                  <FormGroup>
                    <FormTitle noBorder>Add a custom message</FormTitle>
                  </FormGroup>
                  <Field
                    component={FormGroupAdapter}
                    validate={validateRequired()}
                    defaultValue={SHARING_MODAL[shareWithType].text}
                    name="message"
                    placeholder="Enter message here…"
                    type="textarea"
                    minRows={3}
                    parse={(value) => (value === '' ? null : value)}
                  />
                </>
              )}

              {showProposalLink && (
                <ProposalLink
                  onCopyLink={handleCopyLink}
                  onSaveLink={handleSaveLink}
                  loadTailInfo={loadTailInfo}
                  link={link}
                  id={props.itemId}
                />
              )}

              <FormActions isRight>
                <Button htmlType="submit" disabled={submitting || hasValidationErrors}>
                  Send
                </Button>
              </FormActions>
              {/* <pre style={{ fontSize: '16px' }}>{JSON.stringify(values, 0, 2)}</pre> */}
            </div>

            {/* <div className={s.section}>
              <FormTitle hint="Create a read-only (or view-only) Itinerary link for anyone to access.">
                Get Link
              </FormTitle>
              <Field
                component={FormGroupAdapter}
                name="linkSharing"
                type="checkbox"
                labelText={<strong>Turn on Link Sharing</strong>}
              />
              <Divider />
              <Field
                component={FormGroupAdapter}
                name="ownDomain"
                type="checkbox"
                labelText={<strong>Use Your Own Domain</strong>}
              />

              <Text accent>
                This allows you to create a custom link within your agency website and is a Tier II feature. Please
                explore available upgrades to learn more.
              </Text>
            </div> */}
          </form>
        )}
      />
    </>
  );
}

export default ShareForm;
